function clickToSelected(item, myModel,key) {
  

  return {
    onClick: (e) => {
        // console.log(e)
        try {
          if (
            e &&
            e.path &&
            e.path.length > 0 &&
            e.path[0].className &&
            e.path[0].className
          ) {
            var cName = e.path[0].className
            console.log(typeof(cName))
            console.log(e)
            if (typeof(cName) == "string" && cName.indexOf('ant-btn') >= 0 || cName == 'copyItem' || cName == 'zzbBtn') return
          }
        } catch (error) {
          console.log(error)
        }
        console.info(item)
        var hasSelected = false
        var nextItems = []
        var nextKeys = []
        myModel.selectedRows.map((k) => {
          if (k[key] == item[key] + '') {
            hasSelected = true
          } else {
            nextItems.push(k)
            nextKeys.push(k[key] + '')
          }
        })
        if (!hasSelected) {
          nextItems.push(item)
          nextKeys.push(item[key])
        }
        myModel.selectedRows = nextItems
        myModel.selectedRowKeys = nextKeys    
      }}
}

function rowSelection(myModel,key){
    return {
        selectedRowKeys: myModel.selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => {
            myModel.selectedRows = selectedRows
            myModel.selectedRowKeys = selectedRowKeys
      },
        columnWidth: '40px',
        getCheckboxProps: (record) => ({ name: record[key]+'' }),
      }
}

function fillAllSeleted(itemList,myModel,key){
    myModel.selectedRows = itemList
    myModel.selectedRowKeys = []
    myModel.selectedRows.map((k) => {
        myModel.selectedRowKeys.push(k[key]+'')
            })
}

export default {clickToSelected,rowSelection,fillAllSeleted}